import { useContext } from 'react'
import { AlertContext } from 'data/context/alert-context'

export function UseAlert() { return useContext(AlertContext) }